import React from "react";
import { Link } from "react-router-dom";
import mediaService from "../services/mediaService";

function HeroSection({
  title,
  subtitle,
  heroImage,
  useSlider = false,
  sliderImages = [],
  currentSlide = 0,
  onSlideChange,
  ctaText,
  ctaHref = "/contact",
  preTitle,
  children,
}) {
  const resolveUrl = (value) => {
    if (!value) return "";
    return value.startsWith("http") ? value : mediaService.getFileUrl(value);
  };

  const getBackgroundImage = () => {
    const raw =
      useSlider && sliderImages.length > 0
        ? sliderImages[currentSlide]
        : heroImage;
    if (!raw) return "";
    return resolveUrl(raw);
  };

  const backgroundImage = getBackgroundImage();

  const heroStyle = backgroundImage
    ? {
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('${backgroundImage}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : {};

  return (
    <section
      className="text-white py-20 relative bg-gradient-to-r from-[#1F3A5F] to-[#3B82F6] bg-cover bg-center"
      style={heroStyle}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        {preTitle && <div className="mb-6">{preTitle}</div>}
        <h1 className="text-5xl font-bold mb-4">{title}</h1>
        {subtitle && (
          <p className="text-xl mb-8 max-w-3xl mx-auto">{subtitle}</p>
        )}
        {children}
        {ctaText && (
          <Link
            to={ctaHref}
            className="bg-white text-blue-600 px-8 py-3 rounded-full text-lg font-semibold hover:bg-gray-100 transition inline-block"
          >
            {ctaText}
          </Link>
        )}

        {useSlider && sliderImages.length > 0 && (
          <div className="flex justify-center gap-2 mt-8">
            {sliderImages.map((_, index) => (
              <button
                key={index}
                type="button"
                onClick={() => onSlideChange && onSlideChange(index)}
                className={`h-2 rounded-full transition ${
                  index === currentSlide ? "bg-white w-8" : "bg-white/50 w-2"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default HeroSection;
